function getEnvironmentLabel() {
  const explicitEnv = (import.meta.env.VITE_APP_ENV || '').toLowerCase();

  if (explicitEnv === 'production' || explicitEnv === 'prod') return null;
  if (explicitEnv === 'staging' || explicitEnv === 'stage') return 'STAGE';
  if (explicitEnv === 'development' || explicitEnv === 'dev') return 'DEV';

  if (typeof window === 'undefined') return null;

  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return 'DEV';
  if (host.includes('maksab-app.com') || host.includes('staging') || host.includes('stage')) {
    return 'STAGE';
  }

  return null;
}

export function EnvironmentBadge() {
  const label = getEnvironmentLabel();
  if (!label) return null;

  return (
    <div className="pointer-events-none fixed right-0 top-0 z-[9999] h-20 w-20 overflow-hidden">
      <div className="absolute right-[-36px] top-[14px] w-32 rotate-45 bg-red-600 py-1 text-center text-[11px] font-bold uppercase tracking-wider text-white shadow-lg ring-1 ring-white/40">
        {label}
      </div>
    </div>
  );
}
